import React from "react";
import { TodoList, TodosControls } from "./";

const Todos = () => {
  
  return (
    <div>
      <h1>Todos</h1>
      <TodoList />
      <h2>And some controls</h2>
      <TodosControls />
    </div>
  );
};
export default Todos;
